import { useEffect, useCallback, useState } from "react";

const useAutoResizingTextarea = (textareaRef, value, setValue,parentValueToTriggerHeight) => {
  const [mounted, setMounted] = useState(false); 

  const adjustHeight = useCallback(() => {
    if (textareaRef?.current) {
      textareaRef.current.style.height = "auto"; 
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; 
    }
  }, [textareaRef]);

  useEffect(() => {
    setMounted(true); 
  }, []);

  useEffect(() => {
    if (mounted && textareaRef?.current) {
      setTimeout(adjustHeight, 0);
    }
  }, [value, mounted, adjustHeight]);

  useEffect(() => {
  adjustHeight()
  },[parentValueToTriggerHeight])

  const handleInputChange = (e) => {
    setValue(e.target.value); 
    adjustHeight(); 
  };

  return { handleInputChange };
};

export default useAutoResizingTextarea;
